import React, { Component } from 'react';
import { AppBar, Typography, Box } from '@mui/material';

export default class BasicAppBar extends Component {

    render() {
        return (
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Typography class="page-header">{this.props.title}</Typography>
                </AppBar>
            </Box>
        );
    }
}  